const regexForIdentifier = (i) => { return new RegExp(`(${i})+`, 'g') }

const getMatches = (identifiers, originalFormat) => {
  return identifiers.map((i) => {
    const match = originalFormat.match(regexForIdentifier(i))
    return match && match.length ? match[0] : null
  }).filter(Boolean)
}

const getStartIndex = (originalFormat, str) => {
  return originalFormat.indexOf(str)
}

const getEndIndex = (originalFormat, str) => {
  return originalFormat.indexOf(str) + (str.length)
}

const transformFormatToDateTime = (dateJs: object, originalFormat: string) => {
  const timeIdentifiers = ['H', 'h', 'm', 'S', 's', 'A', 'a']
  const dateIdentifiers = ['Y', 'M', 'D', 'd']

  const times = getMatches(timeIdentifiers, originalFormat)
  const dates = getMatches(dateIdentifiers, originalFormat)

  const hour = dateJs.hour()
  const minute = dateJs.minute()
  let format = originalFormat

  if (hour === 0 && minute === 0 && times && times.length) {
    let startIndex = Math.min(...times.map(i => getStartIndex(format, i)))
    let endIndex = Math.max(...times.map(i => getEndIndex(format, i)))

    const dateIndexBeforeStartIndex = dates.map(i => getEndIndex(format, i)).sort((a, b) => b - a).find(i => i < startIndex)
    const dateIndexAfterEndIndex = dates.map(i => getStartIndex(format, i)).sort((a, b) => a - b).find(i => i > startIndex)

    // if date before time startIndex
    if (dateIndexBeforeStartIndex && !dateIndexAfterEndIndex) {
      startIndex = dateIndexBeforeStartIndex
    }

    // if date after time endIndex
    if (dateIndexAfterEndIndex && !dateIndexBeforeStartIndex) {
      endIndex = dateIndexAfterEndIndex
    }

    // if date before time startIndex && if date after time endIndex
    if (dateIndexAfterEndIndex && dateIndexBeforeStartIndex) {
      endIndex = dateIndexAfterEndIndex
    }

    const strToRemove = originalFormat.substring(startIndex, endIndex)
    format = originalFormat.replace(strToRemove, '')
  }

  return format
}

export default transformFormatToDateTime
